import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const bannerBaseStyle = css`
  display: flex;
  gap: ${theme.spacing(2)};
  padding: ${theme.spacing(2)};
  color: ${theme.colors.neutral90};
  border-radius: ${theme.borderRadius.medium};
  align-items: center;
  max-width: 700px;
`;

export const bannerStatusStyles = {
  warn: css`
    background-color: ${theme.colors.warning5};
    border: 1px solid ${theme.colors.warning50};
  `,
  success: css`
    background-color: ${theme.colors.success5};
    border: 1px solid ${theme.colors.success50};
  `,
  error: css`
    background-color: ${theme.colors.critical5};
    border: 1px solid ${theme.colors.critical50};
  `,
  info: css`
    background-color: ${theme.colors.primary5};
    border: 1px solid ${theme.colors.primary50};
  `,
};

export const bannerFullWidthStyle = css`
  max-width: 100%;
`;
